export const bundleConstants = {
  FETCH_START: "FETCH_START",
  FETCH_END: "FETCH_END",
  SET_BUNDLE_COURSES: "SET_BUNDLE_COURSES",
  RESET_BUNDLE_COURSES: "RESET_BUNDLE_COURSES",
};
